<template>
   <el-table
    :data="detail"
    border
    fit
    row-key="materialId"
    :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
    :span-method="objectSpanMethod"
    :summary-method="getSummaries"
    show-summary
  >
    <slot name="prev"/>
     <el-table-column prop="fee" label="单价(含税)" fixed min-width="100" align="right">
      <template #default="{ row }">
        {{$currency(row.fee)}}
      </template>
    </el-table-column>
    <template v-if="mode !== 'storage'">
      <el-table-column prop="feeWidthoutRate" label="单价(未税)" fixed min-width="100" align="right"/>
      <el-table-column prop="totalFeeWidthoutRate" label="总价(未税)" fixed min-width="100" align="right"/>
      <el-table-column prop="totalFee" label="总价(含税)" fixed min-width="100" align="right"/>
      <el-table-column prop="rate" label="税率" fixed min-width="60">
        <template #default="{ row }">
          {{ row.rate}}%
        </template>
      </el-table-column>
    </template>

    <el-table-column prop="amount" label="数量" fixed min-width="60"/>
    <template v-if="storageVisible">
      <el-table-column prop="inputStorageNum" label="已入库数量" min-width="100">
        <template #default="{ row }">
          <span>{{ row.inputStorageNum || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remainAmount" label="剩余数量" min-width="100">
        <template #default="{ row }">
          <span>{{ row.remainAmount || 0}}</span>
        </template>
      </el-table-column>
    </template>
    <el-table-column prop="materialNo" label="物料编号" min-width="160">
      <template #default="{ row }">
        <span>{{ row.materialNo || row.no}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="materialName" label="物料名称" min-width="120" show-overflow-tooltip>
       <template #default="{ row }">
        <span>{{ row.materialName || row.name}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="materialBrand" label="物料品牌" min-width="100" show-overflow-tooltip>
      <template #default="{ row }">
        <span>{{ row.materialBrand || row.brand}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="materialModel" label="物料型号" min-width="120" show-overflow-tooltip >
      <template #default="{ row }">
        <span>{{ row.materialModel || row.model}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="materialUnit" label="物料单位" min-width="100" show-overflow-tooltip>
      <template #default="{ row }">
        <span>{{ row.materialUnit || row.unit}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="materialStandard" label="封装规格" min-width="120" show-overflow-tooltip>
      <template #default="{ row }">
        <span>{{ row.materialStandard || row.standard}}</span>
      </template>
    </el-table-column>
    <template v-if="mode === 'purchase'">
      <el-table-column prop="materialCreateUser" label="申请人" min-width="110" show-overflow-tooltip/>
      <el-table-column prop="materialAmount" label="申请数量" min-width="120"/>
    </template>
    <template v-if="mode === 'storage'">
      <el-table-column prop="materialLocation" label="入库位置" min-width="160" show-overflow-tooltip/>
      <el-table-column prop="locationAmount" label="入库数量" min-width="120"/>
      <el-table-column prop="availableAmount" label="可出库数量" min-width="120"/>
      <el-table-column prop="locationMark" label="入库备注" min-width="120"/>
    </template>

    <el-table-column prop="total" label="合计" fixed="right" min-width="100">
      <template #default="{ row }">
        <span>{{handleRoundNum(row.fee * row.amount)}}</span>
      </template>
    </el-table-column>
    <slot name="after"/>
  </el-table>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, computed, onMounted, watch } from 'vue'
import type { TableColumnCtx } from 'element-plus/es/components/table/src/table-column/defaults'
import $number from 'number-precision'
import { uniqBy } from 'lodash'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'

export default defineComponent({
  props: {
    materialData: { type: Object, required: false, default: () => null },
    storageVisible: { type: Boolean, required: false, default: true },
    mode: { type: String, required: false, default: 'purchase' }
  },
  setup(props) {
    interface User {
      id: string;
      name: string;
      amount1: string;
      amount2: string;
      amount3: number;
    }
    interface SpanMethodProps {
      row: User;
      column: TableColumnCtx<User>;
      rowIndex: number;
      columnIndex: number;
    }
    const dataMap = reactive({
      detail: props.materialData,
      megreColumn: ['materialNo', 'no', 'materialName', 'name', 'materialBrand', 'brand', 'materialModel', 'model', 'materialUnit', 'unit', 'amount', 'fee', 'total', 'materialStandard', 'standard', 'remainAmount', 'storageNum', 'inputStorageNum', 'command'],
      storageVisible: props.storageVisible,
      spanArrChange: computed(() => {
        const megre = ['materialNo']
        const data = dataMap.detail
        const spanArr = {} as any
        megre.forEach((m: any) => {
          spanArr[m] = { spanArr: [], pos: 0 }
        })
        data.forEach((row: any, i: any) => {
          megre.forEach(m => {
            if (i === 0) {
              spanArr[m].spanArr.push(1)
              spanArr[m].pos = 0
            } else {
              if (row[m] === data[i - 1][m]) {
                spanArr[m].spanArr[spanArr[m].pos] += 1
                spanArr[m].spanArr.push(0)
              } else {
                spanArr[m].spanArr.push(1)
                spanArr[m].pos = i
              }
            }
          })
        })
        return spanArr
      }),
      objectSpanMethod({ column, rowIndex }: SpanMethodProps) {
        if (column.type === 'selection' || dataMap.megreColumn.includes(column.property)) {
          return {
            rowspan: dataMap.spanArrChange.materialNo.spanArr[rowIndex],
            colspan: 1
          }
        } else {
          return { rowspan: 1, colspan: 1 }
        }
      },
      getSummaries(param: any) {
        const { columns, data } = param
        let sums: string[] = []
        dataMap.handleCalcTotal()
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item: any) => Number(item[column.property]))
          if (['materialAmount', 'amount', 'total', 'remainAmount', 'storageNum', 'inputStorageNum'].includes(column.property) && !values.every((value: any) => Number.isNaN(value))) {
            sums[index] = `${values.reduce((prev: any, curr: any) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return $number.plus(prev, curr)
              }
              return prev
            }, 0)}`
          } else {
            sums[index] = ''
          }
        })

        sums = sums.map((k: any) => {
          const value = Number(k)
          if (value && !Number.isNaN(value)) {
            return dataMap.handleRoundNum(value).toString()
          }
          return k
        })
        return sums
      },
      handleRoundNum(number: number) {
        return Math.round(number * 100) / 100
      },
      handleCalcTotal() {
        dataMap.detail.forEach((item: any) => {
          item.total = Number(item.fee) * Number(item.amount)
        })
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),

      priceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => priceWithoutRate(price, isCurrency, rate),

      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => totalPriceWithoutRate(price, amount, isCurrency, rate),

      handleData() {
        const tempArray = [] as any
        props.materialData.forEach((item: any) => {
          const tempObj = {
            ...item,
            materialNo: item.material.no,
            materialClass: item.material.materialClass,
            materialUnit: item.material.materialUnit,
            materialStandard: item.material.standard,
            materialId: item.material.id,
            materialBrand: item.material.brand,
            materialName: item.material.name,
            materialModel: item.material.model,
            materialCode: item.material.code,
            materialParameter: item.material.parameter,
            materialDevice: item.material.device,
            id: item.material.id,
            uniqId: item.material.id,
            name: item.material.name,
            total: dataMap.handleRoundNum(item.amount * item.fee),
            storageNum: item.storageNum || 0,
            inputStorageNum: (item.inputStorageNum ? item.inputStorageNum : item.storageNum) || 0,
            remainAmount: item.inputStorageNum ? (item.amount * 1 - item.inputStorageNum * 1) : (item.amount * 1 - (item.storageNum || 0))
          }
          if (item.list?.length) {
            item.list.forEach((k: any, index: number) => {
              const fee = index === 0 ? item.fee : 0
              const amount = index === 0 ? item.amount : 0
              tempArray.push({
                ...tempObj,
                materialAmount: k.amount,
                materialCreateUser: k.createUser,
                uniqId: k.id,
                total: index === 0 ? tempObj.total : 0,
                fee,
                amount,
                remainAmount: index === 0 ? tempObj.remainAmount : 0,
                inputStorageNum: index === 0 ? tempObj.inputStorageNum : 0,
                feeWidthoutRate: dataMap.priceWithoutRate(fee, amount, true, item.rate),
                totalFeeWidthoutRate: dataMap.totalPriceWithoutRate(fee, amount, true, item.rate),
                totalFee: dataMap.numberTimes(fee, amount, true)
              })
            })
          } else if (item.storages?.length) {
            item.storages.forEach((k: any, index: number) => {
              const fee = index === 0 ? item.fee : 0
              const amount = index === 0 ? item.amount : 0
              tempArray.push({
                ...tempObj,
                materialLocation: k.location.location,
                locationMark: k.location.mark,
                locationAmount: k.amount,
                availableAmount: k.availableAmount,
                uniqId: k.id,
                total: index === 0 ? tempObj.total : 0,
                fee,
                amount,
                remainAmount: index === 0 ? tempObj.remainAmount : 0,
                inputStorageNum: index === 0 ? tempObj.inputStorageNum : 0,
                feeWidthoutRate: dataMap.priceWithoutRate(fee, amount, true, item.rate),
                totalFeeWidthoutRate: dataMap.totalPriceWithoutRate(fee, amount, true, item.rate),
                totalFee: dataMap.numberTimes(fee, amount, true)
              })
            })
          } else {
            const fee = tempObj.fee || 0
            const amount = tempObj.amount || 0
            tempArray.push({
              ...tempObj,
              feeWidthoutRate: dataMap.priceWithoutRate(fee, amount, true, item.rate),
              totalFeeWidthoutRate: dataMap.totalPriceWithoutRate(fee, amount, true, item.rate),
              totalFee: dataMap.numberTimes(fee, amount, true)
            })
          }
          if (props.mode === 'storage') {
            dataMap.detail = tempArray
          } else {
            dataMap.detail = uniqBy(tempArray, 'uniqId')
          }
        })
      }
    })
    watch(() => props.materialData, () => {
      dataMap.handleData()
    }, {
      deep: true
    })
    onMounted(() => {
      dataMap.handleData()
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
